"use client";
import "../chunk-GOCCUU3Z.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { CpslIcon, CpslSpinner, CpslText } from "@getpara/react-components";
import styled from "styled-components";
function HeroSpinner({
  icon,
  status = "inactive",
  text
}) {
  return /* @__PURE__ */ jsxs(Root, { children: [
    /* @__PURE__ */ jsxs(Hero, { children: [
      /* @__PURE__ */ jsx(Spinner, { size: 150, barWidth: 9, variant: status === "loading" ? "default" : status }),
      icon && /* @__PURE__ */ jsx(CpslIcon, { icon, size: "80px" })
    ] }),
    /* @__PURE__ */ jsxs(Text, { status, children: [
      status === "error" && /* @__PURE__ */ jsx(CpslIcon, { icon: "alertCircle", size: "16px", style: { stroke: "currentColor" } }),
      /* @__PURE__ */ jsx(CpslText, { variant: "bodyM", weight: "semiBold", color: status === "error" ? "error" : "primary", children: text })
    ] })
  ] });
}
const Root = styled.div`
  height: 276px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;
const Hero = styled.div`
  width: 150px;
  height: 150px;
  margin: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const Text = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  color: ${({ status }) => status === "error" ? "var(--cpsl-color-utility-red)" : "auto"};
`;
const Spinner = styled(CpslSpinner)`
  position: absolute;
  width: 150px;
  height: 150px;
  top: 0;
  left: 0;
  right: 0;
`;
export {
  HeroSpinner
};
